module.exports = __webpack_public_path__ + "img/caigou.aeb4727f.png";